import { useMemo } from 'react';
import { useFormikContext } from 'formik';
import { ButtonProps, Tooltip } from '@mui/material';
import { isMacOS } from '@/common/application/utils/platformUtils';
import { useCtrlEnterHotkey } from '../../../hooks/useCtrlEnterHotkey';
import Button from '@/common/presentation/components/inputs/Button';
import tid from '@/common/infrastructure/config/tid';
import { useFeatureFlag } from '../../../hooks/useFeatureFlag';
import { FEATURE_FLAGS } from '@/common/domain/constants/featureFlags';

export const FormikSubmitFormButton = ({
  isHotkeyEnabled = true,
  testId,
  tooltip,
  ...rest
}: {
  testId?: string;
  isHotkeyEnabled?: boolean;
  tooltip?: string;
} & ButtonProps) => {
  const { submitForm } = useFormikContext();
  const areHotkeysEnabled = useFeatureFlag(FEATURE_FLAGS.ENABLE_HOTKEYS);
  useCtrlEnterHotkey(submitForm, isHotkeyEnabled);
  const shortcutText = useMemo(() => (isMacOS() ? '⌘+Enter' : 'Ctrl+Enter'), []);

  const button = (
    <Button
      {...rest}
      onClick={(e) => {
        if (rest.onClick) {
          rest.onClick(e);
          return;
        }
        // Trigger Formik submit programmatically for reliability in tests and portals
        e.preventDefault();
        if (typeof submitForm === 'function') submitForm();
      }}
      {...(testId && tid(testId))}
    />
  );

  if (!areHotkeysEnabled || rest.disabled) {
    return button;
  }

  return (
    <Tooltip title={tooltip ? tooltip : shortcutText} placement="top" arrow>
      <span>{button}</span>
    </Tooltip>
  );
};
